<vwui-root>
    @if (menuVisible) {
        <a11y-skip-link>{{ 'A11Y.go_to_content' | translate }}</a11y-skip-link>
    } @else {
        <a11y-skip-link> [skipToElement]="'.skip-element'">{{ 'A11Y.go_to_content' | translate }}</a11y-skip-link>
    }

        <vwui-nav>
            <vwui-logo slot="logo" [logoSrc]="'/assets/images/logo.svg'"></vwui-logo>

            <app-menu type="projects"></app-menu>

            <div slot="nav-footer">
                @if (userHasLogin)  {
                    <div class="nav-logout-wrapper">
                        <vwui-nav-item
                            iconName="vwui-user"
                            (click)="logout()"
                            href="/logout"
                            tabindex="-1">
                            {{ 'BUTTON.logout' | translate }}
                            <vwui-icon class="small" iconName="vwui-logout"></vwui-icon>
                        </vwui-nav-item>
                    </div>
                    <div class="nav-version-wrapper"></div>
                }
            </div>
        </vwui-nav>

    <vwui-main>
        <router-outlet></router-outlet>
    </vwui-main>
</vwui-root>
